module.exports = __webpack_public_path__ + "img/WorkOrderTemplate.fd60b71b.svg";